import React from 'react';
import Sidebar from '../learnSidebar';
import NavbarLearn from '../navbarLearn';
import useDocumentTitle from '../useDocumentTitle'

export default function Five() {
    useDocumentTitle("Chapter 5 | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">05</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">CADDING FOR FRC</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">CAD IS THE KEY TO SUCCESS</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">CHAPTER OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">Let's create a blueprint!</p>
                        <p class="font-productsans text-base text-black mt-5">This chapter goes over a more detailed guide of Onshape, as well as some other important design considerations. Check out the topics below:</p>
                        <a href="/learn/five">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 5</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">CADDING FOR FRC</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/five/a">Onshape Featurescripts and Preexisting Libraries</a>
                                    <p class="font-productsans font-normal ml-3">Onshape features and community projects that make the designing process easier.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/five/b">FRC Design Calculator</a>
                                    <p class="font-productsans font-normal ml-3">Learn to make informed design decisions using a simplified calculator.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/five/c">Guided Gearbox Demonstration</a>
                                    <p class="font-productsans font-normal ml-3">Follow an example step-by-step to learn how to start designing.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}